<template>
  <b-modal
    id="alert-modal"
    hide-footer
    hide-header
    centered
    size="lg"
    content-class="p-3 text-center bg-light styled-modal"
  >
    <div class="row">
      <div class="col-lg-5 d-none d-lg-inline-block">
        <div class="new-modal-img">
          <img
            class="align-middle"
            :src="image"
            width="90%"
          >
        </div>
      </div>

      <div class="col-12 col-lg-7 ">
        <div class="row new-modal-text-div">
          <div>
            <h3 class="new-modal-title">
              {{ info.title }}
            </h3>
          </div>

          <div class="new-modal-text">
            <div v-if="info.text">
              <p
                class="mb-2"
                style="vertical-align: middle"
                v-html="info.text"
              />
            </div>

            <div v-if="info.list">
              <ul
                class="list-unstyled mb-0"
              >
                <li
                  v-for="(error, index) in info.list"
                  :key="index"
                  v-html="info.list[index][0].charAt(0).toUpperCase() + info.list[index][0].slice(1)"
                />
              </ul>
            </div>
          </div>

          <div class="new-modal-buttons">
            <div
              v-if="info.buttons"
              id="new-modal-buttons"
              class="text-center"
            >
              <button
                v-for="button in info.buttons"
                :key="button.title"
                type="button"
                :class="button.class + ' m-2'"
                :title="button.title"
                @click="$emit('clickModal',button.click)"
              >
                {{ button.title }}
              </button>
            </div>
            <div
              v-else
              id="alert-button"
              class="text-center"
            >
              <button
                type="button"
                class="btn btn-dark m-2"
                :title="$t('lang.bookings.alert_buttons.accept')"
                @click="$emit('clickModal','closeModal')"
              >
                {{ $t('lang.bookings.alert_buttons.accept') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'ModalAlert',

  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },

  computed: {
    info() {
      return this.modalInfo;
    },
    image() {
      if (this.modalInfo.img) {
        const img = require(`../../assets/img/illustrations/errors/${this.modalInfo.img}.png`);
        return img;
      }
      const img = require('../../assets/img/illustrations/errors/oh-no.png');
      return img;
    },
  },

  methods: {

  },
};
</script>

<style scoped>

</style>
